<template>
  <div class="fix BT">
    <img src="@/assets/img/seek.png" style="width:50%;"
      @click="$emit('addTags',tags.seek,null,null,{ path: '/method',query:{}})">
    <!-- <img v-if="dayLine" src="@/assets/img/sign.png" style="width:50%;" @click="$emit('addTags',tags.sign,null,null,{ path: '/detail',query:{obj: 'signPage'}})"> -->
    <img v-if="dayLine" src="@/assets/img/sign.png" style="width:50%;" @click="showPopup=true">
    <popup @addTags="add_Tags" :popupLocation="popupLocation" v-if="showPopup" @popupStatus="showPopup=false" />
  </div>
</template>

<script>
  import popup from '@/components/popup.vue';
  export default {
    name: 'fixBTComponents',
    props: ['addTags'],
    components: {
      popup,
    },
    data() {
      return {
        popupLocation: "signDeadline",
        showPopup: false,
        dayLine: true,
        tags: {
          "seek": "BA4E6E89979C46FEA26177933AA19D94",
          "sign": "01592D0174334F70A42ADFFA55EBA88B"
        }
      }
    },
    methods: {
      signDeadline() {
        if (new Date() > new Date(this.$store.state.signDeadline)) {
          this.dayLine = true
        }
      },
      add_Tags: function (tag, method, params, page) {
        this.$emit('addTags', tag, method, params, page);
      }
    },
    watch: {},
    created: function () {},
    mounted: function () {}
  }
</script>
<style lang="scss">
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->